export default class PathCapabilitiesDto {

    CanRead: boolean;
    CanAdd: boolean;
    CanAddMultiple: boolean;
    CanUpdate: boolean;
    CanUpdateMultiple: boolean;
    CanDelete: boolean;
    CanDeleteMultiple: boolean;

    constructor(
        canRead: boolean,
        canAdd: boolean,
        canAddMultiple: boolean,
        canUpdate: boolean,
        canUpdateMultiple: boolean,
        canDelete: boolean,
        canDeleteMultiple: boolean
    ) {
        this.CanRead = canRead;
        this.CanAdd = canAdd;
        this.CanAddMultiple = canAddMultiple;
        this.CanUpdate = canUpdate;
        this.CanUpdateMultiple = canUpdateMultiple;
        this.CanDelete = canDelete;
        this.CanDeleteMultiple = canDeleteMultiple;
    }
}
